<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" scrollable max-width="900">
      <v-card>
        <v-toolbar flat color="primary" dark>
          <v-toolbar-title>Sincronizar Sucursales</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialog = !dialog"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="sucursales"
            :loading="loading"
            disable-pagination
            sort-by="calories"
            class="elevation-1"
          >
            <template v-slot:[`item.is_directo`]="{ item }">
              <span> {{ item.is_directo ? 'SI' : 'NO' }} </span>
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <span> {{ item.status }} </span>
              <v-progress-linear indeterminate v-if="item.loading" height="1" />
            </template>
            <template v-slot:[`item.options`]="{ item }">
              <v-btn class="green" dark @click="sincronizarForOne(item)">Sincronizar</v-btn>
            </template>
          </v-data-table>

          <p class="text-center mt-4">{{ msg }}</p>
          <v-progress-linear indeterminate v-if="loading" />
          <!-- <v-btn class="green" dark @click="sincronizar()">Sincronizar</v-btn> -->
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  import { getAccessToken } from '@/accessToken';
  import xaxios from '@/xaxios';
  import axios from 'axios';
  export default {
    data: () => ({
      data: null,
      dialog: false,
      loading: false,
      sucursales: [],
      msg: '',
      headers: [
        {
          text: 'Numero sucursal',
          align: 'start',
          sortable: false,
          value: 'numero_sucursal',
        },
        { text: 'Nit', value: 'nro_nit' },
        { text: 'Tipo', value: 'tipo_facturacion', width: 50 },
        { text: 'Ciudad', value: 'ciudad' },
        { text: 'Municipio', value: 'municipio' },
        { text: '', value: 'status', sortable: false, width: 150 },
        { text: 'Opt', value: 'options', sortable: false, width: 150 },
      ],
    }),

    methods: {
      openmodal(sucursales) {
        this.msg = '';
        this.dialog = true;
        let datas = sucursales.filter((x) => {
          return x.tipo_facturacion.includes('ELECTRÓNICA');
        });
        datas.map((x) => {
          x.status = '...';
          x.loading = false;
        });
        this.sucursales = datas;
        this.obtenerToknFactura();
      },
      getapiheader(s) {
        var config = {
          method: 'put',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/sucursales/codigo`,
          headers: {
            // apikey: this.$store.getters.getApiKey,
            apikey: s.xapikey_facturacion,
          },
          data: {
            codigoSucursal: s.numero_sucursal,
            descripcion: s.direccion,
            direccion: s.direccion,
            estado: 1,
            municipio: s.municipio,
            nombre: s.ciudad,
            telefono: s.telefono,
          },
        };
        return config;
      },
      getapiheaderpost(da) {
        var config = {
          method: 'post',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/sucursales`,
          headers: {
            //apikey: this.$store.getters.getApiKey,
            apikey: da.xapikey_facturacion,
          },
          data: {
            codigoSucursal: da.numero_sucursal,
            descripcion: da.direccion,
            direccion: da.direccion,
            estado: 1,
            municipio: da.municipio,
            nombre: da.municipio,
            telefono: da.telefono,
          },
        };
        return config;
      },
      async sincronizar() {
        let getes = [];
        let vue = this;
        this.sucursales.forEach((s) => {
          s.loading = true;
          s.status = 'actualizando...';
          var config = {
            method: 'get',
            url: `${process.env.VUE_APP_FACT_REST}/facturacion/sucursales/codigo/${s.numero_sucursal}`,
            headers: {
              //apikey: this.$store.getters.getApiKey,
              apikey: s.xapikey_facturacion,
            },
            codigos: s.numero_sucursal,
          };
          const promise1 = xaxios.request(config);
          getes.push(promise1);
        });

        let paracrear = [];
        let paraupdate = [];
        let datos = await Promise.allSettled(getes)
          .then((vals) => (vals ? vals : []))
          .catch((e) => {
            window.console.log(e);
          });

        datos.forEach((d) => {
          if (d.status == 'rejected') {
            paracrear.push(d.reason.config.codigos);
          } else if (d.status != 'rejected') {
            paraupdate.push(d.value.config.codigos);
          }
        });

        window.console.log('getes datos', datos, paracrear, paraupdate);
        let consultas = [];

        this.msg = '';
        this.loading = true;
        this.sucursales.forEach((s) => {
          let url0;
          let iscrear = paracrear.find((x) => x == s.numero_sucursal);
          let isupdate = paraupdate.find((x) => x == s.numero_sucursal);
          window.console.log(iscrear, paraupdate, s);
          if (iscrear != null) url0 = vue.getapiheaderpost(s);
          if (isupdate != null) url0 = vue.getapiheader(s);

          s.loading = true;
          s.status = 'actualizando...';

          const promise1 = xaxios.request(url0);
          consultas.push(promise1);
        });

        Promise.allSettled(consultas)
          .then(function(values) {
            window.console.log('values:::', values);
            vue.sucursales.forEach((s) => {
              s.loading = false;
              s.status = 'ok';
            });
            values.forEach((d) => {
              if (d.status == 'rejected') {
                let ex = vue.sucursales.find((s) => s.numero_sucursal == -1);
                if (ex) ex.status = 'er';
              } else if (d.status != 'rejected') {
                paraupdate.push(d.value.config.codigos);
              }
            });
            vue.loading = false;
            vue.msg = 'Sincronizado';
          })
          .catch((e) => {
            window.console.log(e);
          });
      },

      async sincronizarForOne(s) {
        let getes = [];
        let vue = this;
        /*this.sucursales.forEach((s) => {
          
        });*/

        s.loading = true;
        s.status = 'actualizando...';
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/sucursales/codigo/${s.numero_sucursal}`,
          headers: {
            // apikey: this.$store.getters.getApiKey,
            apikey: s.xapikey_facturacion,
          },
          codigos: s.numero_sucursal,
        };
        const promise1 = xaxios.request(config);
        getes.push(promise1);

        let paracrear = [];
        let paraupdate = [];
        let datos = await Promise.allSettled(getes)
          .then((vals) => (vals ? vals : []))
          .catch((e) => {
            window.console.log(e);
          });

        datos.forEach((d) => {
          if (d.status == 'rejected') {
            paracrear.push(d.reason.config.codigos);
          } else if (d.status != 'rejected') {
            paraupdate.push(d.value.config.codigos);
          }
        });

        window.console.log('getes datos', datos, paracrear, paraupdate);
        let consultas = [];

        this.msg = '';
        this.loading = true;
        /*this.sucursales.forEach((s) => {
          
        });*/

        let url0;
        let iscrear = paracrear.find((x) => x == s.numero_sucursal);
        let isupdate = paraupdate.find((x) => x == s.numero_sucursal);
        window.console.log(iscrear, paraupdate, s);
        if (iscrear != null) url0 = vue.getapiheaderpost(s);
        if (isupdate != null) url0 = vue.getapiheader(s);

        s.loading = true;
        s.status = 'actualizando...';

        const promise2 = xaxios.request(url0);
        consultas.push(promise2);

        Promise.allSettled(consultas)
          .then(function(values) {
            window.console.log('values:::', values);
            /*vue.sucursales.forEach((s) => {
              
            });*/
            s.loading = false;
            s.status = 'ok';
            values.forEach((d) => {
              if (d.status == 'rejected') {
                let ex = vue.sucursales.find((s) => s.numero_sucursal == -1);
                if (ex) ex.status = 'er';
              } else if (d.status != 'rejected') {
                paraupdate.push(d.value.config.codigos);
              }
            });
            vue.loading = false;
            vue.msg = 'Sincronizado';
          })
          .catch((e) => {
            window.console.log(e);
          });
      },

      obtenerToknFactura() {
        let tok = getAccessToken();
        const apiAxios = axios.create({
          baseURL: '',
          headers: {
            'Content-Type': 'application/json',
            Authorization: tok,
          },
        });

        this.sucursales.forEach(async (s) => {
          s.xapikey_facturacion = await apiAxios
            .get(`${process.env.VUE_APP_API_REST}/api/v1/esam/sucursales/${s.id}`)
            .then(({ data }) => (data.apikey ? data.apikey : ''));
        });

        window.console.log('>>>...', this.sucursales);
      },
    },
  };
</script>
